import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, Renderer2, AfterViewInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { EventService } from "../../../core/services/event.service";
import { SharedService } from "src/app/core/services/shared.service";
import { ScriptService } from "src/app/core/services/script.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { formatDate } from "@angular/common";
import { UploadService } from "src/app/core/services/upload.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { MenuEvent } from "src/app/core/services/menuevent.service";
import { AbstractControl } from '@angular/forms';

@Component({
  selector: "app-campo",
  templateUrl: "./campo.component.html",
  styleUrls: ["./campo.component.scss"],
})

export class CampoComponent implements OnInit, OnDestroy, AfterViewInit {
  myFormGroup: FormGroup;
  strWsURLModal: string = "";
  strTituloPantallaModal: string = "";
  scriptElement: any;
  strFOTO: SafeResourceUrl;
  modal_element_label: string;
  modal_element_type: string;
  strSYS03JAV: string = "";
  copiallaves: Array<any> = [];
  CNT05COD: any;
  formespecial = [];
  formcardhidden = [];
  cardsNuevos = [];
  dropzonevisible: boolean = false;
  WsLlavesModal = [];
  WsFiltroModal = [];
  SYS02CON_PAPA_MODAL : string = '';
  @Input() Modal = false;
  @Input() SYS02CON: string = '';
  @Input() Mostrartitulofiltro: boolean = false;
  @Input() ToolbarMS: any;
  @Input() form_template: Observable<any>;
  @Input() strListener: string = "";
  @Input() EventoCerrarMSNavID: string = "";
  @Input() blnMostrarBusqueda: boolean = false;
  @Input() TipoPantalla: string = "";
  @Input() SYS02JAV: string = "";
  @Input() FormID: string = "";
  @Input() strModoCampo: any;
  @Input() Reportes: any;
  @Input() WORKFLOW: any;
  @Input() DOC10ARC: any;
  @Input() PRO10ARC: any;
  @Input() WsLlaves: any = '';
  @Input() WsMasivo = [];
  @Input() AccionesOnChange = [];
  @Input() Origen = "";

  @Output() EventoCerrarMsInterno = new EventEmitter<boolean>();
  @Output() AbrirNuevoNav = new EventEmitter<string>();
  @Output() EventoRecargarMsInterno = new EventEmitter<any>();

  public Editor = Editor;

  opcionesSQL = {
    lineNumbers: true,
    theme: 'material',
    autoRefresh: true,
    mode: 'sql',
    extraKeys: {
      "F11": function (cm) {
        cm.setOption("fullScreen", !cm.getOption("fullScreen"));
      },
      "Esc": function (cm) {
        if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false);
      }
    }
  };


  constructor(
    private eventService: EventService,
    private dataService: SharedService,
    private renderer: Renderer2,
    private scriptService: ScriptService,
    private uploadService: UploadService,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal,
    private menuEvent: MenuEvent, // para apertura de gantt
  ) {
    this.obtener_localstorage();
  }

  // Código para llamdo de base64 según ruta docuemntos - mospina 10-04-2026
  private fotoCache = new Map<string, SafeResourceUrl>();
  private pendingRequests = new Set<string>();
  public strFOTOMap: Record<string, SafeResourceUrl | null> = {};

  public modalOpen = false;
  public modalLabel: string | null = null;

  openModal(label: string) {
    this.modalLabel = label;
    this.modalOpen = true;
  }

  closeModal() {
    this.modalOpen = false;
    this.modalLabel = null;
  }

  ngOnInit(): void {
    
    this.CrearFormulario();

    if (this.form_template !== undefined) {
      for (const i in this.form_template) {
        for (const j in this.form_template[i].cards) {
          if (this.form_template[i].cards[j].type == "select_url") {
            this.form_template[i].cards[j].labeldes = "";
            if (this.form_template[i].cards[j].value != "") {
              if (this.form_template[i].cards[j].SYS03DES_URL != "" && this.form_template[i].cards[j].label == this.form_template[i].cards[j].SYS03ALI) {
                this.form_template[i].cards[j].labeldes = this.form_template[i].cards[j].SYS03DES_URL;
                if (this.form_template[i].cards[j].SYS03RMP == "S") {
                  this.SelectURL_Change(this.form_template[i].cards[j], null, this.form_template[i].cards[j].value)
                }
              } else {
                if (this.form_template[i].cards[j].label == this.form_template[i].cards[j].SYS03CDE) {
                  this.SelectURL_Change(this.form_template[i].cards[j], null, this.form_template[i].cards[j].value, 1);
                } else {
                  this.SelectURL_Change(this.form_template[i].cards[j], null, this.form_template[i].cards[j].value);
                }
              }
            }
            this.form_template[i].idCard = this.form_template[i].cards[j].id_modal;
          } else if (this.form_template[i].cards[j].type == "select") {
            this.CboClick(this.form_template[i].cards[j], true);

          }

          if (this.form_template[i].cards[j].OnChange != "" && this.form_template[i].cards[j].value != "") {
            this.Select_ocultar(this.form_template[i].cards[j]);
          }
          if (this.form_template[i].cards[j].SYS03RMP == "S" && this.form_template[i].cards[j].type != "hidden") {
            this.cardsNuevos.push(this.form_template[i].cards[j]);
          }
          if (this.form_template[i].cards[j].type == "dropzone") {
            this.form_template[i].cards[j].files = [];
          }
          if (this.form_template[i].cards[j].type == "password") {
            this.form_template[i].cards[j].tipo = "password";
          }
        }
      }
    }
  }

  onSelect(event, elemento) {
    elemento.files = [];
    for (const iterator of event.addedFiles) {
      const reader = new FileReader();
      reader.readAsDataURL(iterator);
      reader.onload = () => {
        let base64 = String(reader.result);
        iterator.base64 = base64.split(',')[1];
        iterator.nombre = iterator.name;
        iterator.tipo = iterator.type;
        elemento.files.push(iterator);
        this.myFormGroup.get(elemento.label)?.setValue(elemento.files);
      };
    }
  }

  onRemove(event, elemento) {
    elemento.files.splice(elemento.files.indexOf(event), 1);
  }

  onReady(editor, isReadOnly: boolean) {
    if (isReadOnly) {
      editor.enableReadOnlyMode(editor.id);
    }
  
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return new Base64UploadAdapter(loader);
    };
  }

  ngAfterViewInit(): void {
    this.CargarScript();
  }

  // Método para cargar el script
  CargarScript() {
    if (this.SYS02JAV == undefined) this.SYS02JAV = "";
    if (this.strSYS03JAV == undefined) this.strSYS03JAV = "";

    if (this.SYS02JAV != "" || this.strSYS03JAV != "") {
      this.scriptElement = this.scriptService.loadJsScript(
        this.renderer,
        this.SYS02JAV + "\n" + this.strSYS03JAV
      );
    }
  }

  CrearFormulario() {
    let group = {};
    if (this.form_template !== undefined && this.form_template != null) {
      this.form_template.forEach((itemCard) => {
        let card = itemCard.cards;
        if (card !== undefined && card != null) {
          card.forEach((item) => {
            let valor = item.value;
            if (item.type == "textbox_date" && valor != "") {
              // Las fechas hay que convertirlas (diferentes formatos)
              valor = this.normalizarFecha(valor);
            }

            if (item.type == "checkbox" && (valor == item.CheckBoxFalse || valor == "")) {
              valor = false;
            }

            if (item.type == "cmodel_json") {
              if (this.validarJSON(item.value)) {
                valor = item.value.replaceAll("|", "\"");
                item.value = item.value.replaceAll("|", "\"");
              }
            }

            if (item.type == "cmodel_sql") {
              item.encabezados = [];
              item.filas = [];
              try {
                item.value = atob(item.value).replaceAll("@", "'");
                item.value = item.value.replaceAll("|", "'");
              } catch (error) { }
            }

            if (item.type == "dropzone") {
              item.files = [];
              valor = [];
            }

            if(item.type == "select_multiple"){
              try {
                if(item.value != ""){
                  valor = item.value.replaceAll("\"", "").split(",");
                }else{
                  valor = [];
                }
              } catch (error) { }
              item.value = valor;
            }

            let validores = [];
            if (item.validators.required) {
              validores.push(Validators.required);

            }

            if (item.A10COD == "varchar" && item.A03LON > 0 && item.type != "select_multiple") {
              validores.push(Validators.maxLength(item.A03LON));
              validores.push(Validators.minLength(0));
            }

            if (item.type == "email") {
              validores.push(Validators.email);
            }

            if (item.type == "textbox_date") {
              validores.push(Validators.pattern('^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$'));
            }

            if (item.type == "select_url" && (item.A10COD == "decimal" || item.A10COD == "int")) {
              validores.push(Validators.pattern('^[0-9]*$'));
            }

            group[item.label] = new FormControl(
              { value: valor, disabled: false }, Validators.compose(validores)
            );

            if (item.SYS03ALI != undefined) {
              this.formespecial[item.label] = item.SYS03ALI;
            }

            if (item.SYS03JAV !== undefined) {
              if (item.SYS03JAV != "") {
                this.strSYS03JAV =
                  this.strSYS03JAV + "\n\n" + atob(item.SYS03JAV);
              }
            }
          });
        }
      });
      // Se comenta por que no tiene funcionalidad - mospina 10-04-2026
      //this.ViewFile();
    }
    this.myFormGroup = null;
    this.myFormGroup = new FormGroup(group);
    this.copiallaves.push(this.myFormGroup.value);

    // Código para llamdo de base64 según ruta docuemntos - mospina 10-04-2026
    if (this.form_template) {
      this.form_template.forEach(cardGroup => {
        if (cardGroup.cards) {
          cardGroup.cards.forEach(card => {
            try {
              if (card && card.type === 'fotografia') {
                const control = this.myFormGroup.get(card.label);
                this.watchFotoForControl(card.label, control);
              }
            } catch (e) {
              // safe-guard en caso de que algo no exista
              console.warn('watchFotoForControl error', e);
            }
          });
        }
      });
    }

  }

  /**
   * mospina 31-09-2026 EPT 
   * Método que normaliza la fecha segun el formato devuelto por el back
   */
  private normalizarFecha(valor: any): string {
    if (valor == null || valor === '') {
      return '';
    }
  
    // Si ya es Date
    if (valor instanceof Date) {
      if (isNaN(valor.getTime())) {
        return '';
      }
  
      return formatDate(valor, 'yyyy-MM-dd', 'en');
    }
  
    const fecha = String(valor).trim();
  
    // yyyy-MM-dd
    if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
      return fecha;
    }
  
    // dd/MM/yyyy
    let match = fecha.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  
    if (match) {
      const [, dia, mes, anio] = match;
  
      return `${anio}-${mes}-${dia}`;
    }
  
    // dd-MM-yyyy
    match = fecha.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  
    if (match) {
      const [, dia, mes, anio] = match;
  
      return `${anio}-${mes}-${dia}`;
    }
  
    // yyyy/MM/dd
    match = fecha.match(/^(\d{4})\/(\d{2})\/(\d{2})$/);
  
    if (match) {
      const [, anio, mes, dia] = match;
  
      return `${anio}-${mes}-${dia}`;
    }
  
    // yyyy-MM-ddTHH:mm:ss...
    if (/^\d{4}-\d{2}-\d{2}T/.test(fecha)) {
      return fecha.substring(0, 10);
    }
  
    // Si no se conoce el formato, intentar como Date
    const fechaDate = new Date(fecha);
  
    if (!isNaN(fechaDate.getTime())) {
      return formatDate(fechaDate, 'yyyy-MM-dd', 'en');
    }
  
    console.log('Formato de fecha no reconocido:', valor);
  
    return '';
  }  

  validarJSON(texto) {
    let caracteres = texto.length;
    if (texto[0] == "{" && texto[caracteres - 1] == "}") {
      return true;
    } else {
      return false;
    }
  }


  Exportar() {
    if (this.myFormGroup.valid) {
      this.eventService.broadcast(
        "EVENTO_REFRESAR_LISTA_" + this.strListener,
        JSON.stringify(this.myFormGroup.value)
      );
    } else {
      alert("campos necesarios");
    }

  }

  DemeFormulario() {
    return this.myFormGroup.value;
  }

  formatearFormulario(form) {

    for (const key in form) {
      if (form[key] == null) {
        form[key] = "";
      }

      if (Array.isArray(form[key])) {
        if (form[key].length > 0) {
          if (form[key][0].base64 == null) {
            form[key] = "'" + form[key].join("','") + "'";
          }
        } else {
          if (this.getElemento(key).type != 'dropzone') {
            form[key] = "";
          }
        }
      } else if (form[key] == Number(form[key])) {
        form[key] = String(form[key]);
      }

      if (form[key] == "true" || form[key] == "false") {
        for (const i in this.form_template) {
          for (const j in this.form_template[i].cards) {
            if (this.form_template[i].cards[j].label == key) {
              if (form[key] == "true") {
                form[key] = this.form_template[i].cards[j].CheckBoxTrue;
              } else if (form[key] == "false") {
                form[key] = this.form_template[i].cards[j].CheckBoxFalse;
              }
              break;
            }
          }
        }
      }
    }

    return form;
  }

  ValidarFormulario() {
    if (this.myFormGroup.valid) {
      let objForm = this.formatearFormulario(this.myFormGroup.value);
      this.eventService.broadcast(
        "EVENTO_REFRESAR_LISTA_" + this.strListener,
        JSON.stringify(objForm)
      );
    } else {
      alert("campos necesarios");
    }

  }

  AbrirModal(contenido, elemento) {
    if (elemento.A04MOD != 'N' && elemento.disabled != 'S') {
      this.modal_element_label = elemento.label;
      this.modal_element_type = elemento.type;

      this.WsLlavesModal = [{ MODO: "INSERT", ...this.WsLlaves }];
      this.SYS02CON_PAPA_MODAL = this.SYS02CON;
      this.WsFiltroModal = [{...this.DemeFormulario()}];
      this.strWsURLModal = "api/mantenimientos/ListarGenerico/" + elemento.id_modal;
      this.strTituloPantallaModal = elemento.titulo_modal;
      this.modalService.open(contenido, { size: "xl" });
    }
  }

  RetornoModal(event) {
    if (event.length > 0) {
      let retorno = event[0];
      let cambios = [];
      let claves = Object.keys(retorno);
      claves.forEach((key) => {
        if (key == "TSTAMP") {
          key = this.myFormGroup.value.TSTAMP;
        } else if (this.modal_element_label == key) {
          const formControl = this.myFormGroup.get(key);
          if (formControl) {
            formControl.setValue(retorno[key]);
            cambios.push({ label: key, valor: retorno[key], parametro: 1 });
          }
        } else if (this.modal_element_label != key) {
          if (this.TienePropiedad(key)) {
            if (claves.length <= 2) {
              const formControl = this.myFormGroup.get(this.modal_element_label);
              formControl.setValue(retorno[key]);
              cambios.push({ label: this.modal_element_label, valor: retorno[key], parametro: null });
            } else {
              const formControl = this.myFormGroup.get(key);
              formControl.setValue(retorno[key]);
              cambios.push({ label: key, valor: retorno[key], parametro: null });
            }
          } else {
            const formControl = this.myFormGroup.get(key);
            if (formControl != null) {
              formControl.setValue(retorno[key]);
              cambios.push({ label: key, valor: retorno[key], parametro: 1 });
            }
          }
        }
      });

      for (const i in cambios) {
        let elemento = this.getElemento(cambios[i].label);
        if (elemento.url_select != null) {
          this.SelectURL_Change(elemento, null, cambios[i].valor, cambios[i].parametro);
        }
        if (elemento.ComboClick == "S") {
          this.CboClick(elemento);
        }
        this.Select_ocultar(elemento);
      }
    }
    this.modalService.dismissAll();
  }

  getElemento(label) {
    for (const i in this.form_template) {
      for (const j in this.form_template[i].cards) {
        if (this.form_template[i].cards[j].label == label) {
          return this.form_template[i].cards[j];
        }
      }
    }
  }

  TienePropiedad(propiedad) {
    for (const key in this.formespecial) {
      if (this.formespecial[key] == propiedad && key == this.modal_element_label) {
        return true;
      }
    }
    return false;
  }

  onSelectChange(event) {
  }

  // almora 2021.11.06 Destroy se ejecuta
  ngOnDestroy(): void {
    if (this.form_template !== undefined && this.form_template != null) {
      this.form_template.forEach((input_template) => {
        input_template = null;
      });
    }
    this.myFormGroup.reset();
    this.myFormGroup = null;
    this.form_template = null;
    if (this.SYS02JAV != "")
      this.scriptElement.parentNode.removeChild(this.scriptElement);
  }

  EventoClickMS(obj, url, evento, id, boton, formato) {
    let btn = document.getElementById(id) as HTMLButtonElement;
    let llaves = [];
    llaves.push(JSON.parse(JSON.stringify(this.myFormGroup.value)));
    llaves[0] = this.formatearFormulario(llaves[0]);
    var jsonFiltros = this.toJSON(evento,
      llaves,
      url,
      (this.WORKFLOW != null ? ('"WORKFLOW":' + JSON.stringify(this.WORKFLOW)) : ""),
      (this.DOC10ARC != null ? ('"DOC10ARC":' + JSON.stringify(this.DOC10ARC)) : "") +
      (this.PRO10ARC != null ? ('"PRO10ARC":' + JSON.stringify(this.PRO10ARC)) : ""));
    if (evento == "EVENTO_CERRAR") {
      if (this.Modal) {
        this.modalService.dismissAll();
      } else {
        // Cierro el Tab Actual
        this.eventService.broadcast(
          "EventoCerrarMS_" + this.EventoCerrarMSNavID,
          JSON.parse("{}")
        );
        this.CerrarMsInternoClick(false);
      }

    } else if (evento == "DELETE_GENERICO" || evento == "DELETE_WS" || evento == "ANULAR") {
      var mensaje = "Está seguro de Eliminar?"
      if (evento == "ANULAR") mensaje = "Está seguro de anular?"

      Swal.fire({
        title: mensaje,
        text: "No podrás revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No, cancelar!',
        confirmButtonText: evento == "ANULAR" ? 'Si, anularlo' : 'Si, eliminarlo',
      }).then((result) => {
        if (result.isConfirmed) {
          this.dataService.ConsultarWS(url
            , jsonFiltros, btn).subscribe((datosResp: any) => {
              // Todo bien, refresco la lista asociada
              this.eventService.broadcast("EVENTO_REFRESAR_LISTA_" + this.strListener, JSON.parse("{}"));
              // Cierro el Tab Actual
              this.eventService.broadcast("EventoCerrarMS_" + this.EventoCerrarMSNavID, JSON.parse("{}"));
              this.CerrarMsInternoClick(false);
              Swal.fire({
                position: "bottom-end",
                toast: true,
                icon: "success",
                text: "Campo Eliminado Correctamente",
                showConfirmButton: false,
                timer: 5000,
              });

            },
              (error) => {
                Swal.fire({
                  html:
                    '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                    '<div class="col-5">' +
                    ' <img src="assets/images/imageerror.png"> </img>' +
                    "</div>" +
                    ' <div class="col-7">' +
                    "<h3>Error</h3><br>" +
                    " <p>" +
                    error +
                    "</p>" +
                    " </div> ",
                });

              }
            );
        }
      })
    } else if (evento == "ABRIR_GANTT") {
      // mospina 2024.05.15 apertura del gantt
      let arr: any[] = [];
      let objetoJSON = {
        FILTROS_OPCIONALES: [this.WsLlaves],
      }

      let jsonString = JSON.stringify(objetoJSON);
      this.menuEvent.broadcast('ABRIR_NUEVO_TAB', { SYS02CON: 4, titulo: 'Gantt', SYS02TIP: 'GANTT', "JSONllavesMantenimiento": jsonString });
    } else if (evento == "ABRIR_CRONOGRAMA") {
      // mospina 2024.05.15 apertura del gantt detalle
      let arr: any[] = [];
      arr.push(this.WsLlaves);

      let json = this.toJSON("SELECT", arr, "api/mantenimientos/MantenimientoGenerico/lstPRO11ARC");
      this.menuEvent.broadcast('ABRIR_NUEVO_TAB', { SYS02CON: "lstPRO11ARC", titulo: "Cronograma", JSONllavesMantenimiento: json });
    }  else {
      if (this.myFormGroup.valid) {
        let comparacion = JSON.stringify(this.copiallaves) === JSON.stringify(llaves);
        if (evento != "UPDATE_GENERICO" && evento != 'UPDATE_WS') comparacion = false;
        if (comparacion == false && (id == "campo_" + evento || id == "campo2_" + evento)) {
          var operacion = "";
          if (evento == "INSERT_GENERICO") operacion = "Campo Insertado";
          else if (evento == "UPDATE_GENERICO") operacion = "Campo Actualizado";
          if (evento == "IMPRIMIR") {
            // almora 2023.04.13 Si entro por acá, soy el botón de Imprimir del Mantenimiento
            this.VerReporte(this.SYS02CON, boton.SYS10CON, boton.SYS16CON, formato, id)
          } else if (evento == "IMPRIMIR_PERSONAL") {
            this.VerReportePersonalizado(this.SYS02CON, boton.SYS44COD,  "PDF", id)
          } else {
            this.dataService.ConsultarWS(url, jsonFiltros, btn).subscribe((datosResp: any) => {
              // Todo bien, refresco la lista asociada
              if (datosResp?.SYS02CON != null) {
                this.eventService.broadcast("EVENTO_REFRESAR_LISTA_" + datosResp.SYS02CON, JSON.parse("{}"));
              } else {
                this.eventService.broadcast("EVENTO_REFRESAR_LISTA_" + this.strListener, JSON.parse("{}"));
              }

              // Cierro el Tab Actual
              this.eventService.broadcast("EventoCerrarMS_" + this.EventoCerrarMSNavID, JSON.parse("{}"));

              //mospina 30-07-26 - Se valida si viene desde wizard para que no cierre el tab
              if(this.Origen == 'Wizard'){// Solo para mantenimientos del wizard
                this.EventoRecargarMsInterno.emit(datosResp);
              }else{
                if (datosResp?.WKF10COD != null) {
                  this.CerrarMsInternoClick(datosResp);
                } else if (datosResp?.DOC10COD != null) {
                  this.CerrarMsInternoClick(datosResp);
                } else {
                  this.CerrarMsInternoClick(false);
                }
              }

              this.modalService.dismissAll();
              if (datosResp?.codigoVerificacion != null) {
                Swal.fire({
                  icon: 'info',
                  html: '<p>El código de verificación para la firma digital es: <b>' + datosResp.codigoVerificacion + '</b></p>',
                  titleText: 'Código de verificación'
                });
              } else if (datosResp?.base64 != null) {
                const blob = this.dataURItoBlob(datosResp.base64, datosResp.tipo);
                let fileURL = URL.createObjectURL(blob);
                if (datosResp.tipo == 'application/pdf') {
                  window.open(fileURL, '_blank');
                } else {
                  let link = document.createElement('a');
                  if (datosResp.nombre != null) {
                    link.download = datosResp.nombre;
                  } else {
                    let tipoPartes = datosResp.tipo.split('/');
                    if (tipoPartes.length > 1) {
                      link.download = 'documento.' + tipoPartes[1];
                    } else {
                      link.download = 'documento';
                    }
                  }
                  link.href = fileURL;
                  link.click();
                }
              } else {
                Swal.fire({
                  position: "bottom-end",
                  toast: true,
                  icon: "success",
                  text: operacion + " Correctamente",
                  showConfirmButton: false,
                  timer: 5000,
                });
              }
            },
              (error) => {
                Swal.fire({
                  html:
                    '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                    '<div class="col-5">' +
                    ' <img src="assets/images/imageerror.png"> </img>' +
                    "</div>" +
                    ' <div class="col-7">' +
                    "<h3>Error</h3><br>" +
                    " <p>" +
                    error +
                    "</p>" +
                    " </div> ",
                });
              }
            );
          }
        } else {
          if (evento == "UPDATE_GENERICO" || evento == "UPDATE_WS") {
            Swal.fire({
              html:
                '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                '<div class="col-5">' +
                ' <img src="assets/images/imageerror.png"> </img>' +
                "</div>" +
                ' <div class="col-7">' +
                "<h3>Error</h3><br>" +
                " <p>No se han encontrado cambios</p>" +
                " </div> ",
            });
          }
        }
      } else {
        const invalid = [];
        const controls = this.myFormGroup.controls;
        for (const name in controls) {
          if (controls[name].invalid) {
            invalid.push(name);
          }
        }
        this.form_template.forEach((input_template) => {
          for (let i = 0; i < input_template.cards.length; i++) {
            for (let j = 0; j < invalid.length; j++) {
              if (invalid[j] == input_template.cards[i].label) {
                invalid[j] = input_template.cards[i].title;
              }
            }
          }
        });
        Swal.fire({
          html:
            '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
            '<div class="col-5">' +
            ' <img src="assets/images/imageerror.png"> </img>' +
            "</div>" +
            ' <div class="col-7">' +
            "<h3>Error</h3><br>" +
            " <p>Por favor verifique los campos requeridos: </p>" +
            "<p>" +
            invalid.join(", ") +
            "</p>" +
            " </div> ",
        });
      }
    }
  }

  toJSON(operacion: string, arr: any[], url?: string, extra?: string, extra2?: string) {

    if (arr.length > 0 && this.WsMasivo.length > 0) {
      Object.assign(arr[0], this.WsMasivo[0]);
    }

    let jsonResult: any = {
      LLAVES: arr,
      URL: url != null ? url : "",
      OPERACION: operacion,
      MASIVO: this.WsMasivo
    }
    if (extra != '' && extra != null) {
      jsonResult = Object.assign(jsonResult, JSON.parse('{' + extra + '}'));
    }
    if (extra2 != '' && extra2 != null) {
      jsonResult = Object.assign(jsonResult, JSON.parse('{' + extra2 + '}'));
    }

    return jsonResult;
  }

  CerrarMsInternoClick(blnRefrescar: boolean) {
    this.EventoCerrarMsInterno.emit(blnRefrescar);
  }

  CboClick(elemento, insert = false) {
    if (insert && elemento.value =="") return;
    if (elemento.ComboClick == "S") {
      this.form_template.forEach((input_template) => {
        for (let i = 0; i < input_template.cards.length; i++) {
          if (input_template.cards[i].label == elemento.ComboClickDestName) {
            let llaves = JSON.stringify(this.formatearFormulario(JSON.parse(JSON.stringify(this.myFormGroup.value))));
            let jsonFiltros = JSON.parse('{ "LLAVES"   : [' + llaves + '],"MODO": "'+this.strModoCampo+'"}');
            this.dataService.Ejecutar("api/mantenimientos/ListarCombo/" + input_template.cards[i].ComboClickURL, jsonFiltros).subscribe(
              (datosResp: any) => {
                input_template.cards[i].options = datosResp;
                if (!insert) {
                  input_template.cards[i].value = "";
                  this.myFormGroup.get(input_template.cards[i].label)?.setValue("", { emitEvent: false });
                }
              },
              (error) => {
                Swal.fire({
                  html:
                    '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                    '<div class="col-5">' +
                    ' <img src="assets/images/imageerror.png"> </img>' +
                    "</div>" +
                    ' <div class="col-7">' +
                    "<h3>Error</h3><br>" +
                    " <p>" +
                    error +
                    "</p>" +
                    " </div> ",
                });
              }
            );
          }
        }
      });
    }

    this.Select_ocultar(elemento);
  }

  Select_ocultar(elemento, evento = null) {
    let OnChangeURL = elemento.OnChange;
    if (OnChangeURL != "" && OnChangeURL != null) {
      let jsonFiltros = { LLAVES: [this.formatearFormulario(JSON.parse(JSON.stringify(this.myFormGroup.value)))] };
      this.dataService.ConsultarWS(OnChangeURL, JSON.stringify(jsonFiltros)).subscribe(
        (datosResp: any) => {
          if (datosResp != null) {
            let allElements = Object.keys(this.myFormGroup.value);
            for (const valor of allElements) {
              let modificar = this.getElemento(valor);
              modificar.oculta = false;
            }

            if (datosResp.campos != null) {
              for (const campo of datosResp.campos) {
                if (campo.ocultar) {
                  let modificar = this.getElemento(campo.nombre);
                  if (modificar != null) {
                    modificar.oculta = true;
                  }
                }

                if (campo.valor !== undefined) {
                  this.actualizarValorCampo(campo.nombre, campo.valor);
                }
              }
            }
          }
        },
        (error) => {
          Swal.fire({
            html:
              '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-5">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              "</div>" +
              ' <div class="col-7">' +
              "<h3>Error</h3><br>" +
              " <p>" +
              error +
              "</p>" +
              " </div> ",
          });
        }
      );
    } else {
      let elementoValor = elemento.value;
      if (evento != null) {
        if (elemento.type == 'checkbox') {
          if (evento.target.checked == true) {
            elementoValor = elemento.CheckBoxTrue;
          } else {
            elementoValor = elemento.CheckBoxFalse;
          }
        } else if (elemento.type == 'radio') {
          if (evento.target.value == 'on') {
            elementoValor = this.myFormGroup.get(elemento.label).value;
          }
        } else {
          elementoValor = evento.target.value;
        }
      }

      for (const i in this.AccionesOnChange) {
        let campoOrigen = this.AccionesOnChange[i].Campo;
        let campoValores = this.AccionesOnChange[i].Valores.split(',');
        if (campoOrigen == elemento.label) {
          let camposDestino = this.AccionesOnChange[i].Destino.split(',');
          for (const j in camposDestino) {
            let elementoDestino = this.getElemento(camposDestino[j]);
            if (campoValores.includes(elementoValor)) {
              if (this.AccionesOnChange[i].OcultarDestino == 'S') {
                elementoDestino.oculta = true;
                this.myFormGroup.get(elementoDestino.label).clearValidators();
                this.myFormGroup.get(elementoDestino.label).updateValueAndValidity();
              }

              if (this.AccionesOnChange[i].AsignarValor == 'S') {
                this.myFormGroup.get(camposDestino[j]).setValue(this.AccionesOnChange[i].ValorAsignar);
              }
            } else {
              elementoDestino.oculta = false;
              if (elementoDestino.validators.required) {
                this.myFormGroup.get(elementoDestino.label).addValidators(Validators.required);
                this.myFormGroup.get(elementoDestino.label).updateValueAndValidity();
              }
            }
          }
        }
      }
    }
  }

  actualizarValorCampo(nombre: string, valor: any): void {
    const elemento = this.getElemento(nombre);
    const control = this.myFormGroup.get(nombre);
  
    if (!elemento || !control) {
      return;
    }
  
    const valorFinal =
      elemento.type === 'select_multiple' && (valor === null || valor === undefined || valor === '')
        ? []
        : (valor === null || valor === undefined ? '' : valor);
  
    elemento.value = valorFinal;
    control.setValue(valorFinal, { emitEvent: false });
    control.markAsDirty();
    control.updateValueAndValidity({ emitEvent: false });
  }

  cargarCombo(evento, elemento) {
    if (elemento.ComboPrecargado == "S") {
      if (evento.term.length > 2) {
        let tiempo = Date.now();
        if (elemento.comboTime == null || (tiempo - elemento.comboTime) > 3000) {
          elemento.comboTime = tiempo;
          let formulario = this.myFormGroup.value;
          let campoDes = elemento.label.substring(0, elemento.label.length - 3);
          formulario[campoDes + 'DES'] = evento.term;
          let parametros = { LLAVES: [this.formatearFormulario(formulario)] };
          this.dataService.ConsultarWS("api/mantenimientos/ListarCombo/" + elemento.ComboClickURL, JSON.stringify(parametros)).subscribe((datos: any) => {
            elemento.options = datos.DATA;
          }, (err: any) => {

          });
        }
      }
    }
  }

  SelectURL_Change(elemt, evento, value, parametro = null) {
    let valor = "";
    if (value != null) {
      valor = value;
    } else {
      valor = evento.target.value;
    }
    if (valor === "") {
    } else {
      let llavesdes = [];
      llavesdes.push(this.formatearFormulario(JSON.parse(JSON.stringify(this.myFormGroup.value))));

      if (elemt.SYS03ALI != "" && elemt.SYS03ALI != undefined && parametro != 1) {
        llavesdes[0][elemt.SYS03ALI] = valor;
      }

      // Ejecuto la operacion en el backend
      var jsonFiltros = this.toJSON(
        "BUSCAR_DESCRIPCION",
        llavesdes,
        elemt.url_select + elemt.id_modal
      );

      this.dataService.ConsultarWS(elemt.url_select, jsonFiltros).subscribe(
        (datosResp: any) => {
          if (datosResp.CamposMS != undefined) {
            if (datosResp.CamposMS.length > 0) {
              for (const key in datosResp.CamposMS) {
                let encontro = false;
                for (const key1 in this.formcardhidden) {
                  if (datosResp.CamposMS[key].descripcion == this.formcardhidden[key1].descripcion) {
                    encontro = true;
                    this.formcardhidden[key1] = datosResp.CamposMS[key];
                    this.formcardhidden[key1].idCard = datosResp.SYS02CON;
                    break;
                  }
                }
                if (encontro == false) {
                  let fila = datosResp.CamposMS[key];
                  fila.idCard = datosResp.SYS02CON;
                  this.formcardhidden.push(fila);
                }
              }

              for (const i in this.cardsNuevos) {
                for (const j in this.formcardhidden) {
                  for (const k in this.formcardhidden[j].cards) {
                    if (this.formcardhidden[j].cards[k].label == this.cardsNuevos[i].label) {
                      if (this.strModoCampo == "INSERT" || this.strModoCampo == "UPDATE") {
                        this.myFormGroup.get(this.formcardhidden[j].cards[k].label).setValue(this.formcardhidden[j].cards[k].value);
                        this.CboClick(this.cardsNuevos[i]);
                        if (elemt.label == this.formcardhidden[j].cards[k].label) {
                          this.consultarDescripcion(elemt, jsonFiltros);
                        }
                      }

                      if (this.formcardhidden[j].cards[k].type == this.cardsNuevos[i].type) {
                        this.cardsNuevos[i].options = this.formcardhidden[j].cards[k].options;
                      }
                      this.formcardhidden[j].cards.splice(k, 1);
                    }
                  }
                }
              }

              for (const i in this.formcardhidden) {
                for (const j in this.form_template) {
                  if (this.form_template[j].idCard == this.formcardhidden[i].idCard && this.form_template[j].idCard == datosResp.SYS02CON) {
                    for (const k in this.formcardhidden[i].cards) {
                      let indice = this.form_template[j].cards.findIndex((x) => x.label == "span_" + this.formcardhidden[i].cards[k].label);
                      if (indice == -1) {
                        let fila = this.formcardhidden[i].cards[k];
                        fila.label = "span_" + fila.label;
                        this.form_template[j].cards.push(fila);
                        this.myFormGroup.addControl(
                          fila.label,
                          new FormControl(
                            {
                              value: this.formcardhidden[i].cards[k].value,
                              disabled: false,
                            },
                            []
                          )
                        );
                        // Código para llamdo de base64 según ruta docuemntos - mospina 10-04-2026
                        this.watchFotoForControl(fila.label, this.myFormGroup.get(fila.label));
                      } else {
                        this.form_template[j].cards[indice] = this.formcardhidden[i].cards[k];
                        this.form_template[j].cards[indice].label = "span_" + this.form_template[j].cards[indice].label;
                        this.myFormGroup.get(this.form_template[j].cards[indice].label).setValue(this.formcardhidden[i].cards[k].value);
                      }
                    }
                    break;
                  }
                }
              }
            }
          } else {
            for (var clave in datosResp.DATA[0]) {
              let descripcion = datosResp.DATA[0][clave];
              if (elemt.SYS03CDE != "") {
                elemt.labeldes = descripcion;
              }
            }
          }
        },
        (error) => {
          Swal.fire({
            html:
              '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-5">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              "</div>" +
              ' <div class="col-7">' +
              "<h3>Error</h3><br>" +
              " <p>" +
              error +
              "</p>" +
              " </div> ",
          });
        }
      );
    }

    // almora 2024.07.05 Si soy Select_URL y tengo configurado propagar el cambio a un combo, lo ejecuto
    if (elemt.ComboClick == 'S' && this.strModoCampo == "INSERT") {
      this.CboClick(elemt);
    }
  }

  consultarDescripcion(elemento, jsonFiltros) {
    this.dataService.ConsultarWS('api/mantenimientos/BuscarDescripcion/' + elemento.A02COD, jsonFiltros).subscribe(resp => {
      if (resp.DATA.length > 0) {
        elemento.labeldes = resp.DATA[0][elemento.SYS03CDE];
      }
    });
  }

  ViewFile() {
    let url = this.uploadService.viewFile(
      JSON.parse('{"TIPO": "M12ARC", "LLAVES": [ { "M12CAR": "01704878" } ]}')
    );
    this.strFOTO = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  // Código para llamdo de base64 según ruta docuemntos - mospina 10-04-2026
  
  // Se registra el control para que cuando cambie su valor cargue la foto
  private watchFotoForControl(label: string, control: AbstractControl | null) {
    if (!control) return;
    // cargar inicial
    this.loadFotoForLabel(label, control.value);
    // actualizar cuando cambie
    control.valueChanges.subscribe(val => this.loadFotoForLabel(label, val));
  }

  private loadFotoForLabel(label: string, controlValue: string | null | undefined) {
    if (!controlValue) {
      this.strFOTOMap[label] = null;
      return;
    }
    const key = String(controlValue);

    // si ya está en cache, asignar y salir
    const cached = this.fotoCache.get(key);
    if (cached) {
      this.strFOTOMap[label] = cached;
      return;
    }

    // si ya hay petición en curso, no pedir de nuevo
    if (this.pendingRequests.has(key)) return;

    this.pendingRequests.add(key);

    const llaves = { LLAVES: [{ URL: key }] };
    const llavesJsonString = JSON.stringify(llaves);

    this.dataService.ConsultarWS('api/servicios/FotoBase64', llavesJsonString).subscribe({
      next: (datosResp5: any) => {
        try {
          // según indicas, la respuesta es el base64 string
          const base64 = (typeof datosResp5[0].BASE64 === 'string') ? datosResp5[0].BASE64 : null;
          if (base64) {
            const dataUrl = base64.startsWith('data:') ? base64 : `data:image/jpeg;base64,${base64}`;
            const safe = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);
            this.fotoCache.set(key, safe);
            this.strFOTOMap[label] = safe;
          } else {
            this.strFOTOMap[label] = null;
          }
        } catch (e) {
          console.error('Error procesando foto base64', e);
          this.strFOTOMap[label] = null;
        } finally {
          this.pendingRequests.delete(key);
        }
      },
      error: (err) => {
        console.error('Error al obtener foto base64', err);
        this.pendingRequests.delete(key);
        this.strFOTOMap[label] = null;
      }
    });
  }

  // AbrirReportePDFNav
  // Método para abrir un PDF en una cejilla
  AbrirReportePDFNav(
    idx: number,
    intSYS02CON: string,
    intSYS10CON: string,
    intTSTAMP: string,
    strSYS10DES: string
  ) {
    let llaves: Array<string> = [];
    llaves.push(this.myFormGroup.value);

    let arr = JSON.parse(
      '{    "FILTROS_OPCIONALES"   : [' +
      JSON.stringify(this.DemeFormulario()) +
      "]" +
      ' , "SYS02CON"   : ' +
      intSYS02CON +
      ' , "SYS10CON"   : ' +
      intSYS10CON +
      ' , "TSTAMP"     : ' +
      intTSTAMP +
      ' , "TITULO"     : "' +
      strSYS10DES +
      '"' +
      ' , "FILTROS_OBLIGATORIOS" : ' +
      JSON.stringify(llaves) +
      "}"
    );

    // Armo el JSON
    let json = this.toJSON(
      "ABRIR_REPORTE_PDF",
      arr,
      "api/mantenimientos/VerReporte/" +
      intSYS02CON +
      "/" +
      intSYS10CON +
      "/" +
      intTSTAMP,
      strSYS10DES
    );

    this.AbrirNuevoNav.emit(json);
  }

  obtener_localstorage() {
    this.CNT05COD = localStorage.getItem("X-AVATAR-CNT05COD");
  }

  SelectIcons(event, element) {
    element.value = event.target.value
  }

  contrasena(element) {

    if (element.tipo === "password") {
      element.tipo = "text"
    } else {
      element.tipo = "password"
    }
  }

  clasesElemento(elemento) {
    if (elemento.oculta) {
      return "ocultar-div";
    } else {
      if (elemento.SYS03TXT == 'S') {
        return "col-12";
      } else {
        return "col-6";
      }
    }
  }

  VerReporte(intSYS02CON: string, intSYS10CON: string, intSYS16CON: string, strFORMATO: string, llaves?) {
    let strjson = "{      \"FILTROS_OPCIONALES\"   : []" +
      " , \"SYS02CON\"   : \"" + intSYS02CON + "\" " +
      " , \"SYS10CON\"   : " + intSYS10CON +
      " , \"SYS16CON\"   : " + intSYS16CON +
      " , \"FORMATO\"    : \"" + strFORMATO + "\" " +
      " , \"TITULO\"     : \"\"" +
      " , \"FILTROS_DASHBOARD\"    : [] " +
      " , \"FILTROS_OBLIGATORIOS\" : [" + JSON.stringify(this.formatearFormulario(this.myFormGroup.value)) + "]}";
    let arr = JSON.parse(strjson);
    let json = this.toJSON("ABRIR_REPORTE_PDF", arr, "api/mantenimientos/VerReporte/" + intSYS02CON + "/" + intSYS10CON + "/" + intSYS16CON);
    this.dataService.ConsultarWS('api/mantenimientos/VerReporte/' + intSYS02CON + '/' + intSYS10CON + '/' + intSYS16CON, json).subscribe(
      (datosResp: any) => {
        const base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
        const blob = this.dataURItoBlob(base64, strFORMATO);
        let fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      }
    );
  }
  VerReportePersonalizado(intSYS02CON: string, intSYS44COD: string,  strFORMATO: string, llaves?) {
    let strjson = "{      \"FILTROS_OPCIONALES\"   : []" +
      " , \"SYS02CON\"   : \"" + intSYS02CON + "\" " +
      " , \"SYS44COD\"   : \"" + intSYS44COD + "\" " +
      " , \"FORMATO\"    : \"" + strFORMATO + "\" " +
      " , \"TITULO\"     : \"\"" +
      " , \"FILTROS_DASHBOARD\"    : [] " + 
      " , \"FILTROS_OBLIGATORIOS\" : [" + JSON.stringify(this.formatearFormulario(this.myFormGroup.value)) + "]}";
    let arr = JSON.parse(strjson);
    let json = this.toJSON("ABRIR_REPORTE_PDF", arr, "api/mantenimientos/VerReportePersonalizado/" + intSYS02CON + "/" + intSYS44COD );
    this.dataService.ConsultarWS('api/mantenimientos/VerReportePersonalizado/' + intSYS02CON + '/' + intSYS44COD , json).subscribe(
      (datosResp: any) => {
        const base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
        const blob = this.dataURItoBlob(base64, strFORMATO);
        let fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      }
    );
  }

  dataURItoBlob(dataURI, strFORMATO) {
    let strType = "application/pdf";
    if (strFORMATO == "XLS") strType = "application/vnd.ms-excel";
    if (strFORMATO == "SQL") strType = "application/octet-stream";
    if (strFORMATO == "TXT") strType = "text/plain";
    if (strFORMATO == "XML") strType = "application/xml";
    if (strFORMATO == "ZIP") strType = "application/zip";

    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: strType });
    return blob;
  }

  visor(elemento) {
    let isVisor = true;
    let partes = elemento.value.split(".");
    let extension = partes[partes.length - 1].toLowerCase();
    if (extension == 'pdf') {
      elemento.tipoDocumento = 'data:application/pdf';
    } else if (extension == 'jpg' || extension == 'jpeg' || extension == 'png' || extension == 'gif') {
      elemento.tipoDocumento = 'data:image/' + extension;
    } else {
      isVisor = false;
    }

    return isVisor;
  }

  visorDescargar(elemento) {
    var a = document.createElement("a");
    a.href = "data:application/octet-stream;base64," + elemento.ArchivoBase64;
    a.download = elemento.value;
    a.click();
  }

  ejecutarSQL(elemento) {
    this.dataService.ConsultarWS("api/ws/utils/SQLUtils/ejecutarSQL", JSON.stringify({ sql: elemento.value })).subscribe(
      (datosResp: any) => {
        if (datosResp != null) {
          elemento.encabezados = datosResp.encabezados;
          elemento.filas = datosResp.filas;
        }
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      }

    );
  }

}

class Base64UploadAdapter {
  constructor(private loader: any) {}

  upload() {
    return this.loader.file.then(file => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve({ default: reader.result }); 
      };
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    }));
  }

  abort() {}
}